import { useContext, useMemo } from 'react'
import { useFirestoreGeneralTwoOrderBy } from '../../../firebase/useFirestore'
import Location from '../../../hooks/Location'
import { AdressNavigation } from '../../../StateManagment/AdressNavigation'
import recentAdressVisits from '../../../helpers/recentAdressVisits'

const dateOptions = { day: 'numeric', month: 'short', year: 'numeric' }
const timeOptions = { hour: '2-digit', minute: '2-digit' }

const AgendaCard = () => {
    const adressId = Location()[3]
    const [, setAdressNavigation] = useContext(AdressNavigation)

    // AI-CONTEXT: See docs/pitfalls.md#database-firestore-null-is-a-valid-query-value
    // `Parent: null` is bewust — hoofdafspraken, geen subtaken.
    const tasks = useFirestoreGeneralTwoOrderBy(
        'Tasks',
        'AdressID',
        adressId || '',
        'Parent',
        null,
        'Position',
        'desc'
    )

    const recent = useMemo(() => recentAdressVisits(tasks).slice(0, 3), [tasks])

    return (
        <div className="new-dashboard-card">
            <div className="new-dashboard-card-content">
                <h3 className="new-dashboard-card-title">Recente afspraken</h3>
                {recent.length === 0 ? (
                    <p className="adress-dashboard-empty">Geen afspraken bekend.</p>
                ) : (
                    <ul className="adress-dashboard-list">
                        {recent.map(task => (
                            <li key={task.ID} className="adress-dashboard-list-row">
                                <span className="adress-dashboard-list-title">
                                    {task.Title || '(zonder titel)'}
                                </span>
                                <span className="adress-dashboard-list-meta">
                                    {task.Timestamp.toDate().toLocaleDateString('nl-NL', dateOptions)}
                                    {' · '}
                                    {task.Timestamp.toDate().toLocaleTimeString('nl-NL', timeOptions)}
                                </span>
                            </li>
                        ))}
                    </ul>
                )}
                <button
                    type="button"
                    className="adress-dashboard-view-all"
                    onClick={() => setAdressNavigation('tasks')}
                >
                    Bekijk alle afspraken →
                </button>
            </div>
        </div>
    )
}

export default AgendaCard
